import client from '../../providers/fetchClient'

export const getPartners = (params, configs) => client.get(`/v3/partners?${params}`, configs)

export const getPartnerStatuses = () => client.get('/v3/partner-statuses')

export const updatePartner = (id, body) => client.put(`/v3/partners/${id}`, body)

export const getPartner = id => client.get(`/v3/partners/${id}`)
